import { render, staticRenderFns } from "./CCMVitalEntryAdd.vue?vue&type=template&id=3b8e9514"
import script from "./CCMVitalEntryAdd.vue?vue&type=script&lang=js"
export * from "./CCMVitalEntryAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports